import { useSyncExternalStore } from 'react';

import { debugTelemetryService } from '@/shared/services/debugTelemetryService';

/**
 * Returns the current debug-telemetry flag value, re-rendering whenever
 * `debugTelemetryService.save()` fires a notification.
 *
 * Uses `useSyncExternalStore` so React can derive the value synchronously on
 * both client and server (getServerSnapshot returns false — overlay is never
 * server-side rendered).
 *
 * Automatically subscribes on mount and unsubscribes on unmount via the
 * cleanup function returned by `debugTelemetryService.subscribe`.
 */
export function useDebugFlag(): boolean {
  return useSyncExternalStore(
    debugTelemetryService.subscribe,
    () => debugTelemetryService.getSync(),
    () => false, // server snapshot
  );
}
